/**
 * @generated SignedSource<<9576c6e9e8d00880050143c63a7d3c53>>
 * @relayHash 6f2046b1fb2934993b3473a35cb2e9e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9d81e39c52730ccdb54dff494a5dcfc47e34623db6b52eb0c2b2d6480bdb4072

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOTimeGranularity = "DAY" | "MONTH" | "WEEK" | "%future added value";
export type PerformanceNetworkViewQuery$variables = {
  cloudId: string;
  dimension?: string | null | undefined;
  endDate: AGG$DateTime;
  granularity?: JiraCFOTimeGranularity | null | undefined;
  startDate: AGG$DateTime;
};
export type PerformanceNetworkViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceMonitoringHorizontalBarChart" | "PerformanceNetworkUserCharts">;
};
export type PerformanceNetworkViewQuery = {
  response: PerformanceNetworkViewQuery$data;
  variables: PerformanceNetworkViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": "network_downlink",
  "kind": "LocalArgument",
  "name": "dimension"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": "DAY",
  "kind": "LocalArgument",
  "name": "granularity"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v7 = {
  "kind": "Variable",
  "name": "granularity",
  "variableName": "granularity"
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = {
  "type": "COUNT"
},
v10 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    {
      "aggregation": (v9/*: any*/),
      "name": "user"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v13 = {
  "concreteType": "JiraCFODimension",
  "kind": "LinkedField",
  "name": "dimensions",
  "plural": true,
  "selections": (v12/*: any*/)
},
v14 = {
  "concreteType": "JiraCFOMetric",
  "kind": "LinkedField",
  "name": "metrics",
  "plural": true,
  "selections": (v12/*: any*/)
},
v15 = [
  (v11/*: any*/),
  {
    "concreteType": "JiraCFODataRowConnection",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraCFODataRowEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "timestamp"
              },
              (v13/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PerformanceNetworkViewQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PerformanceNetworkUserCharts"
      },
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "dimension",
            "variableName": "dimension"
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PerformanceMonitoringHorizontalBarChart"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PerformanceNetworkViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "cores",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "cpus"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          {
            "alias": "speed",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "network_downlink"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          {
            "alias": "protocol",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "http_protocol"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          {
            "alias": "os",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "os"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          {
            "alias": "browsers",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "browser_name"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          {
            "alias": "ttvcAnalytics",
            "args": [
              (v5/*: any*/),
              {
                "items": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "dimension"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "dimensions.0"
                  }
                ],
                "kind": "ListValue",
                "name": "dimensions"
              },
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": (v9/*: any*/),
                    "name": "ttvc90"
                  }
                ]
              },
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9d81e39c52730ccdb54dff494a5dcfc47e34623db6b52eb0c2b2d6480bdb4072",
    "metadata": {},
    "name": "PerformanceNetworkViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1455fc444023bdfe833405a03fc3ef2d";

export default node;
